import * as TypeGraphQL from "type-graphql";
export var ScheduledOptionOrderStatus;
(function (ScheduledOptionOrderStatus) {
    ScheduledOptionOrderStatus["PENDING"] = "PENDING";
    ScheduledOptionOrderStatus["EXECUTED"] = "EXECUTED";
    ScheduledOptionOrderStatus["CANCELED"] = "CANCELED";
})(ScheduledOptionOrderStatus || (ScheduledOptionOrderStatus = {}));
TypeGraphQL.registerEnumType(ScheduledOptionOrderStatus, {
    name: "ScheduledOptionOrderStatus",
    description: undefined,
});
//# sourceMappingURL=ScheduledOptionOrderStatus.js.map